import type { FC } from 'react';
import { getAccessibleTabIndex } from '../Button/ariaHelpers';
import { pickTooltipChildNodeProps } from '../Tooltip/Tooltip';
import { getSwitchClassNames } from './Switch.styles';
import type { SwitchProps } from './Switch.types';

export const Switch: FC<SwitchProps> = ({
  value,
  size,
  dataTestId,
  disabled,
  className,
  onChange,
  hasError,
  innerRef,
  ...props
}) => {
  const handleClick = () => {
    if (onChange) {
      onChange(!value);
    }
  };

  const switchClassNames = getSwitchClassNames(
    value,
    size,
    disabled,
    hasError,
    className,
  );

  return (
    <button
      ref={innerRef}
      type='button'
      className={switchClassNames.root}
      data-testid={dataTestId}
      id={props.id}
      onClick={handleClick}
      {...pickTooltipChildNodeProps(props)}
      tabIndex={getAccessibleTabIndex(disabled)}
      disabled={disabled}
    >
      <div className={switchClassNames.wrapper}>
        <div className={switchClassNames.circle} />
      </div>
    </button>
  );
};
